import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { Grid, Section, Typography, Tabel, BreadCrumbBox, Loading } from "../../core";
import { Row, Col } from "antd";
import { MixStyle, theme } from "../../styles";
import { getDispatchesOfContract } from "../../helper/utils/api/dispatch";
import { getContractWithContractId } from "../../helper/utils/api/contract";

const { textColor } = theme;
const CHANGE_DATE_FORMAT = require("../../helper/utils/datFormat");

const StyledSection = styled(Section)`
  ${MixStyle.flexBetween}
`;
const SectionWraper = styled.div`
  span {
    ${MixStyle.flexBetween}
  }
`;

const TypoProps = {
  tittle: { as: "h3", weight: "600" },
  value: { as: "h6", weight: "500", color: textColor.primary },
};

const columns = [
  {
    title: "Date",
    dataIndex: "dispatchDate",
    key: "date",
    render: (text, record) =>
      CHANGE_DATE_FORMAT.changeDateFormat(
        record.dispatchDate || record.date_dispatch
      ),
    width: 150,
  },
  {
    title: "Contract #",
    dataIndex: "contractNo",
    key: "contract_no",
    width: 150,
  },
  {
    title: "Quantity",
    dataIndex: "kachiQuantity",
    key: "quantity",
    render: (text, record) => record.kachiQuantity || record.k_qunatity,
    width: 150,
  },
  {
    title: "K patch parchi #",
    dataIndex: "kachiParchiNumber",
    key: "kpatchparchi",
    render: (text, record) =>
      record.kachiParchiNumber || record.k_patch_parchi_no,
    width: 150,
  },
  {
    title: "Godown",
    dataIndex: "godownAddress",
    key: "godown",
    render: (text, record) => record.godownAddress || record.godown_address,
    width: 150,
  },
];

const DispatchInner = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [dispatch, setDispatch] = useState(null);
  const [contract, setContract] = useState(null);
  const [relatedDispatches, setRelatedDispatches] = useState([]);

  const loadDispatch = useCallback(async () => {
    const contractId =
      location.state?.contractId ||
      location.state?.contract_id ||
      location.state;
    if (!contractId) return;

    setIsLoading(true);
    try {
      const [contractRes, dispatchRes] = await Promise.all([
        getContractWithContractId(contractId),
        getDispatchesOfContract({ contractId, limit: 100 }),
      ]);

      const contractData = contractRes.data?.result?.[0] || {};
      const dispatches = dispatchRes.data?.result || [];
      setContract(contractData);
      setRelatedDispatches(dispatches);
      setDispatch(dispatches[0] || null);
    } catch (error) {
      console.log("dispatch inner error", error);
    }
    setIsLoading(false);
  }, [location.state]);

  useEffect(() => {
    loadDispatch();
  }, [loadDispatch]);

  const netPass =
    dispatch?.netPass ??
    dispatch?.net_pass ??
    (dispatch
      ? Number(dispatch.kachiQuantity || dispatch.k_qunatity || 0) -
        Number(dispatch.lShort || dispatch.l_short || 0) -
        Number(dispatch.glrReceived || dispatch.glr_received || 0)
      : 0);

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <BreadCrumbBox tittle="Dispatch Inner" />
      <Row type="flex" justify="space-between" gutter={[16, 16]}>
        <Col lg={15} xs={24}>
          <StyledSection padding="10px 50px">
            <Typography {...TypoProps.tittle} noMargin>
              Net Pass
            </Typography>
            <Typography {...TypoProps.tittle} color="#FF5687" noMargin>
              {netPass}
            </Typography>
          </StyledSection>
          <Section padding="10px 30px" className="mt-20">
            <Typography {...TypoProps.tittle} color="#233B67">
              General
            </Typography>
            <Tabel
              padding="0px"
              columns={columns}
              data={relatedDispatches.map((d) => ({
                ...d,
                contractNo: contract?.contractNo,
                key: d._id,
              }))}
              pagination={false}
              rowKey="_id"
            />
          </Section>
        </Col>
        <Col lg={9} xs={24}>
          <Section padding="10px 30px">
            <Typography {...TypoProps.tittle} color="#233B67">
              Info
            </Typography>
            <SectionWraper>
              <span>
                <Typography {...TypoProps.value} text="Invoice #" />
                <Typography {...TypoProps.value} color="#FF5687">
                  {dispatch?.invoiceStatus || "pending"}
                </Typography>
              </span>
              <div className="mt-10">
                <span>
                  <Typography {...TypoProps.value} text="C#" />
                  <Typography {...TypoProps.value} color="#FF5687">
                    {contract?.contractNo || "-"}
                  </Typography>
                </span>
                <span>
                  <Typography {...TypoProps.value} text="L short Amount" />
                  <Typography {...TypoProps.value} color="#FF5687">
                    {dispatch?.lShort || dispatch?.l_short || 0}
                  </Typography>
                </span>
                <span>
                  <Typography {...TypoProps.value} text="P patch parchi #" />
                  <Typography {...TypoProps.value} color="#FF5687">
                    {dispatch?.packiParchiNumber || "-"}
                  </Typography>
                </span>
                <span>
                  <Typography {...TypoProps.value} text="K patch parchi #" />
                  <Typography {...TypoProps.value} color="#FF5687">
                    {dispatch?.kachiParchiNumber ||
                      dispatch?.k_patch_parchi_no ||
                      "-"}
                  </Typography>
                </span>
              </div>
            </SectionWraper>
          </Section>
          <Section padding="10px 30px" className="mt-20">
            <Typography {...TypoProps.tittle} color="#233B67">
              Rejection
            </Typography>
            <SectionWraper>
              <span>
                <Typography {...TypoProps.value} text="Rejection" />
                <Typography {...TypoProps.value} color="#FF5687">
                  {dispatch?.glrReceived || dispatch?.glr_received || 0}
                </Typography>
              </span>
              <span>
                <Typography {...TypoProps.value} text="Cloth Return Date" />
                <Typography {...TypoProps.value} color="#FF5687">
                  {dispatch?.clothReturnDate || "-"}
                </Typography>
              </span>
            </SectionWraper>
          </Section>
        </Col>
      </Row>
    </Grid>
  );
};

export default DispatchInner;
